import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  mutation PasswordSetFromForgot($userId: ID!, $newPassword: String!, $confirmation: String!) {
    passwordSetFromForgot(userId: $userId, newPassword: $newPassword, confirmation: $confirmation)
  }
`

export const passwordSetFromForgotKey = getQueryNames(query)[0]

export default query
